import React, { useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Carousel, { Modal, ModalGateway } from 'react-images';
// NOTE: The above package has been deprecated and likely wont work with react v17+
// The author recommends https://github.com/leandrowd/react-responsive-carousel

const Wrapper = styled.div``;

const GlobalStyle = createGlobalStyle`
  // Hide the react-images current image counter due to the hack detailed below.
  .react-images__footer {
    display: none !important;
  }
`;

export const PopUpGallery = ({
  viewerIsOpen,
  closeLightbox,
  currentImage,
  images,
  imagesToPreload = 5, // This needs to be >= the number of thumbnails shown on the page, or, the largest index they can jump straight to
}) => {
  const imageList = images.map(x => ({
    ...x,
    srcset: x.srcSet,
    caption: x.title,
  }));

  // Track our own version of the current index so we can use it for the imagesToShow object
  const [internalIndex, setInternalIndex] = useState(currentImage || 0);

  // react-images will load all the images in the gallery as soon as it is opened. This puts unwanted
  // strain on our resources. So instead, we want to drip feed it images. imagesToShow will contain
  // all images up to and including the current index, plus an additional 5. That way, we only ever
  // load up to 5 unused images. Instead of loading a whole set of ~100 when the user might only look
  // at one or two before bouncing.
  const imagesToShow = imageList.slice(0, internalIndex + imagesToPreload);

  const onViewChange = e => {
    setInternalIndex(e);
  };

  return (
    <Wrapper>
      <GlobalStyle />
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={imagesToShow}
              trackProps={{ onViewChange }}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </Wrapper>
  );
};
